import { Link } from "wouter";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-neutral-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-4">
            <div className="mb-4">
              <img 
                src="https://max.live/hubfs/MAX%20Logo%20-%20Light%2c%20Full%20Color%2c%20Full%20Mark%20-%20Bounding%20Box-1.png" 
                alt="MAX - Music Audience Exchange" 
                className="h-12 w-auto mb-3"
              />
              <h5 className="text-xl font-bold">The MAX Platform™</h5>
            </div>
            <p className="text-neutral-400 mb-4">
              The premier platform for music sponsorship opportunities, connecting brands with artists and their audiences through data-driven insights.
            </p>
          </div>
          
          <div className="md:col-span-2 md:ml-4">
            <h6 className="font-semibold mb-4">Browse</h6>
            <ul className="space-y-2 text-neutral-400">
              <li><Link href="/browse-artists" className="hover:text-white transition-colors">By Artist</Link></li>
              <li><Link href="/browse-venues" className="hover:text-white transition-colors">By Venue</Link></li>
              <li><Link href="/browse-markets" className="hover:text-white transition-colors">By Market</Link></li>
            </ul>
          </div>
          
          <div className="md:col-span-3">
            <h6 className="font-semibold mb-4">Tools</h6>
            <ul className="space-y-2 text-neutral-400">
              <li><Link href="/plans" className="hover:text-white transition-colors">Create Plans</Link></li>
              <li><Link href="/saved" className="hover:text-white transition-colors">Saved Shows</Link></li>
              <li><Link href="/calculator" className="hover:text-white transition-colors">Sponsorship Calculator</Link></li>
            </ul>
          </div>
          
          <div className="md:col-span-3">
            <h6 className="font-semibold mb-4">Support</h6>
            <ul className="space-y-2 text-neutral-400">
              <li><Link href="/help-center" className="hover:text-white transition-colors">Help Center</Link></li>
              <li><Link href="/contact-us" className="hover:text-white transition-colors">Contact Us</Link></li>
              <li><Link href="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-neutral-800 mt-8 pt-8 text-center text-neutral-400">
          <p>&copy; {currentYear} MAX (Music Audience Exchange). All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}